import { render } from "./ObjectField.vue?vue&type=template&id=5dcd6548"
import script from "./ObjectField.vue?vue&type=script&lang=js"
export * from "./ObjectField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__